import React, { useRef } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Typography } from '@material-ui/core'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'

import { SELECT_MODE } from 'app/constants/table'
import PrimaryTooltip from 'app/componentV4/Tooltip/PrimaryTooltip'

const SelectAllSubscriberButton = ({
  allRowsSelected,
  isSelectAllDisabled,
  isSelectAllMode,
  formattedTotalCount,
  handleToggleSelectAll,
  formatMessage,
}) => {
  const infoIconRef = useRef(null)

  if (!allRowsSelected) {
    return null
  }

  return (
    <div className="flex">
      <div className="flex pl-[18px] grow">
        {isSelectAllDisabled ? (
          <PrimaryTooltip
            title={formatMessage({
              id: 'select.all.limit.exceeded',
            })}
            placement="top"
            PopperProps={{
              anchorEl: infoIconRef.current,
              placement: 'top',
            }}
          >
            <div className="flex items-center gap-2">
              <InfoOutlinedIcon
                ref={infoIconRef}
                fontSize="small"
                className="text-orange-600"
              />
              <Typography className="text-14 font-500 cursor-not-allowed underline text-orange-600/30 whitespace-nowrap">
                <FormattedMessage
                  id="create.assign.group.button.select.all"
                  values={{ count: formattedTotalCount }}
                />
              </Typography>
            </div>
          </PrimaryTooltip>
        ) : (
          <Typography
            className="text-14 font-500 cursor-pointer underline text-orange-600 whitespace-nowrap"
            onClick={handleToggleSelectAll}
          >
            {isSelectAllMode ? (
              <FormattedMessage id="create.assign.group.button.clear.select" />
            ) : (
              <FormattedMessage
                id="create.assign.group.button.select.all"
                values={{ count: formattedTotalCount }}
              />
            )}
          </Typography>
        )}
      </div>
    </div>
  )
}

export default SelectAllSubscriberButton
